import i18n from 'modules/core/lib/i18n'

import { isEmployee, isInternalCompany, isPublicCompany } from 'modules/documents/lib/Folders'

import { Folder } from '../hooks/useGetFolders'
import { SPACES } from './constants'

export interface SpaceValues {
  key: (typeof SPACES)[keyof typeof SPACES]
  text: string
}

export function spacesFromFolders(folders: Folder[]) {
  return [
    ...(folders.some((folder) => isEmployee(folder)) ? [SPACES.EMPLOYEE_MY_DOCUMENTS] : []),
    ...(folders.some((folder) => isInternalCompany(folder)) ? [SPACES.COMPANY_INTERNAL] : []),
    ...(folders.some((folder) => isPublicCompany(folder)) ? [SPACES.COMPANY_PUBLIC] : []),
  ]
}

export function spaceToDescription(space: (typeof SPACES)[keyof typeof SPACES]) {
  switch (space) {
    case SPACES.EMPLOYEE_MY_DOCUMENTS:
      return i18n.t('documents.spaces.employee_my_documents')
    case SPACES.COMPANY_INTERNAL:
      return i18n.t('documents.spaces.company_internal')
    case SPACES.COMPANY_PUBLIC:
      return i18n.t('documents.spaces.company_public')
    default:
      return i18n.t('documents.spaces.all')
  }
}
